import React from "react";
import { useForm } from "react-hook-form";
import AlertTemplate from "~/common/components/AlertPortal/AlertTemplate";
import Form from "~/common/components/Form";
import ModalTemplate from "~/common/components/ModalPortal/ModalTemplate";
import Textarea from "~/common/components/textarea";
import vcImg from "~/assets/img/sample/people-sample1.jpg";
import logoImg from "~/assets/img/sample/logoR-company03.png";
import { Trans, useTranslation } from "react-i18next";

const AlertDetail = ({
	commentaryModal,
	setCommentaryModal,
	onlineIrModal,
	setOnlineIrModal,
	resultAnnounceModal,
	setResultAnnounceModal,
	resultAnnounceChkAlert,
	setResultAnnounceChkAlert,
	resultAnnounceAlert,
	setResultAnnounceAlert,
	noResultAnnounceAlert,
	setNoResultAnnounceAlert,
	irInfo,
}) => {
	const { t } = useTranslation();
	const notificationForm = useForm();

	return (
		<>
			{/* ------------------ Modal For Judge.js ------------------- */}
			{/*심사평 모달*/}
			<ModalTemplate
				modalState={commentaryModal}
				setModalToggle={setCommentaryModal}
				width={720}
				height={472}
				className="commentary-modal"
			>
				<div className="modal-content">
					<div className="judge-vc-wrap">
						<div className="row">
							<div className="img-wrap">
								<img
									src={vcImg}
									alt={t(
										"pages.investment.InvestEvalPage.detail.Step.modalForJudge.CommentaryModal.imageAlt"
									)}
								/>
							</div>
							<dl className="judging-vc">
								<dt>vctest</dt>
								<dd />
							</dl>
						</div>
						<div className="judging-vc-score">
							<b>0</b>점
						</div>
					</div>
					<div className="c__form vertical judge-detail-group">
						<div className="f__label">
							test1 카테고리<span>배점비율 : 100점</span>
						</div>
						<div className="f__control">
							<div className="commentary-wrap">
								<div className="commentary">test1 평가항목</div>
								<div data-unit="/10" className="ratio">
									0
								</div>
							</div>
							<div className="commentary-wrap">
								<div className="commentary">test12</div>
								<div data-unit="/10" className="ratio">
									0
								</div>
							</div>
						</div>
					</div>
					<div className="c__form vertical">
						<div className="f__group judge-commentary">
							<div className="f__label">
								{t(
									"pages.investment.InvestEvalPage.detail.Step.modalForJudge.CommentaryModal.label02"
								)}
							</div>
							<div className="f__control">
								<textarea className="c__textarea f__item" readOnly>
									dfsdfsdf
								</textarea>
							</div>
						</div>
					</div>
				</div>
			</ModalTemplate>

			{/*심사하기 모달*/}
			<ModalTemplate
				modalState={onlineIrModal}
				setModalToggle={setOnlineIrModal}
				width={720}
				height={472}
				className="commentary-modal"
			>
				<div className="modal-content">
					<section>sdfsdf</section>
					<section>sfdsfds</section>
				</div>
			</ModalTemplate>

			{/*결과통보 모달*/}
			<ModalTemplate
				modalState={resultAnnounceModal}
				setModalToggle={setResultAnnounceModal}
				title={
					<div className="top">
						<div className="img-wrap">
							<img
								src={logoImg}
								alt={t(
									"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.imageAlt"
								)}
							/>
						</div>
						<h4 className="title">
							<b>(주)일루넥스</b>{" "}
							{t(
								"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.title"
							)}
						</h4>
					</div>
				}
				width={600}
				className="evaluate-notification-modal"
			>
				<div className="modal-content">
					<Form useForm={notificationForm} className="notification-form vertical">
						<Textarea
							label={
								<>
									{t(
										"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.sender"
									)}{" "}
									<span className="sender">시현대표 (벤처스퀘어)</span>
								</>
							}
							name="notification"
							placeholder={t(
								"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.placeholder"
							)}
							// showCount={true}
						/>
					</Form>
				</div>
				<div className="modal-footer">
					<button
						type="button"
						className="btn__solid"
						color="gray"
						onClick={() => setResultAnnounceModal(false)}
					>
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.button01"
						)}
					</button>
					<button
						type="button"
						className="btn__solid"
						color="primary"
						onClick={() => setResultAnnounceChkAlert(true)}
					>
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.button02"
						)}
					</button>
				</div>
			</ModalTemplate>

			{/*----------- 결과통보 버튼 클릭 시 모달 - 전체 심사역이 심사를 안했을 때*/}
			<AlertTemplate
				alertModalState={noResultAnnounceAlert}
				setAlertModalToggle={setNoResultAnnounceAlert}
				alertType="info"
			>
				<p className="alert-content">
					<div className="modal-text pre-wrap">
						{t(
							"pages.investment.InvestEvalPage.detail.Step.alertForJudgeAdmin.AlertForJudgeAdmin.alert"
						)}
					</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
						onClick={() => setNoResultAnnounceAlert(false)}
					>
						{t(
							"pages.investment.InvestEvalPage.detail.Step.alertForJudgeAdmin.AlertForJudgeAdmin.confirm"
						)}
					</button>
				</div>
			</AlertTemplate>

			{/*----------- 결과통보 버튼 클릭 시 모달 - 심사 결과 전달 check*/}
			<AlertTemplate
				alertModalState={resultAnnounceChkAlert}
				setAlertModalToggle={setResultAnnounceChkAlert}
				alertType="warning"
				className="evaluate-notification-modal"
			>
				<p className="alert-content">
					<div className="modal-text">
						<Trans
							i18nKey="pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.alert01"
							components={[irInfo?.IRBasicInfo?.name, <b />]}
						/>
					</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
						onClick={() => setResultAnnounceAlert(true)}
					>
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.button03"
						)}
					</button>
					<button
						className="btn__solid"
						color="gray"
						onClick={() => setResultAnnounceChkAlert(false)}
					>
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.button04"
						)}
					</button>
				</div>
			</AlertTemplate>
			{/*----------- 결과통보 버튼 클릭 시 모달 - 심사 결과 전달 완료*/}
			<AlertTemplate
				alertModalState={resultAnnounceAlert}
				setAlertModalToggle={setResultAnnounceAlert}
				alertType="success"
			>
				<p className="alert-content">
					<div className="modal-text">
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.alert02"
						)}
					</div>
				</p>
				<div className="alert-footer">
					<button
						className="btn__solid"
						color="primary"
						onClick={() => setResultAnnounceAlert(false)}
					>
						{t(
							"pages.investment.InvestEvalPage.detail.Step.modalForJudge.ResultAnnounceModal.button05"
						)}
					</button>
				</div>
			</AlertTemplate>
		</>
	);
};

export default AlertDetail;
